import React from 'react';
import { get } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { closeSnackBar } from '../../actions/snackbarAction';
import './styles.scss';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function SnackbarContainer() {
  const dispatch = useDispatch();
  const visible = useSelector(state =>
    get(state, 'snackbarReducer.visible', false)
  );
  const message = useSelector(state =>
    get(state, 'snackbarReducer.message', '')
  );
  const severity = useSelector(state =>
    get(state, 'snackbarReducer.severity', '')
  );

  const onDismissSnackBar = () => {
    dispatch(closeSnackBar());
  };

  return (
    <Snackbar
      open={visible}
      autoHideDuration={6000}
      onClose={onDismissSnackBar}
    >
      <Alert onClose={onDismissSnackBar} severity={severity}>
        <span className="snackbar-message">{message}</span>
      </Alert>
    </Snackbar>
  );
}
